"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _systemadmin = require("@/api/systemadmin.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  // name: "edit"
  components: {},
  props: {
    adminId: {
      type: Number,
      required: 0
    }
  },
  data: function data() {
    var _this = this;
    var confirmvalidatePass = function confirmvalidatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.pram.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入管理员密码'));
      } else {
        if (_this.pram.confirmPassword !== '') {
          _this.$refs.pram.validateField('confirmPassword');
        }
        callback();
      }
    };
    return {
      constants: this.$constants,
      pram: {
        password: '',
        confirmPassword: '',
        id: 0
      },
      roleList: [],
      rules: {
        password: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }, {
          required: true,
          min: 6,
          max: 20,
          message: '长度6-20个字符'
        }],
        confirmPassword: [{
          required: true,
          validator: confirmvalidatePass,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    close: function close() {
      this.$emit('hideEditPassWordDialog');
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.handlerSave();
      });
    }),
    handlerSave: function handlerSave() {
      var _this3 = this;
      this.pram.id = this.adminId;
      (0, _systemadmin.editPassWordApi)(this.pram).then(function (data) {
        _this3.$message.success('修改密码成功');
        _this3.$emit('hideEditPassWordDialog');
      });
    },
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    }
  }
};